import s from "./teacher-modal.module.scss";
import { Loader } from "./loader";
import { Modal } from "@shared/ui/modal/modal";
import { IconCheck, IconShare2 } from "@tabler/icons-react";
import { Button } from "@shared/ui/button/button";
import { CopyButton } from "@shared/ui/copy-button/copy-button";
import { useNavigate } from "react-router-dom";
import { getNoun } from "utils/lib/getNoun";
import { useMedia } from "use-media";
import { Loader as Spinner } from '@shared/ui/loader/loader';
import { TextCollapse } from "@shared/ui/text-collapse/text-collapse";

import { getFullName } from "utils/lib/getFullname";
import { useTeacherModal } from "../../model/use-teacher-modal";
import { Reviews } from '@entities/teacher/ui/reviews/reviews';
import { useProfile } from "@shared/api/useProfile";
import { useTeacher } from "@entities/teacher/api/useTeacher";
import { Slider } from "./slider";
import { TextWithEmoji } from "@shared/ui/text-with-emoji/text-with-emoji";

export const TeacherModal = () => {
	const { isOpen, close, modalParams } = useTeacherModal()

	const {data: profile} = useProfile()
	const teacherId = profile?.access_level === 'restricted' ? null : modalParams?.teacherId
	const {data: teacher, isLoading} = useTeacher(teacherId)
  const navigate = useNavigate();
	
	const isMobile = useMedia({maxWidth: '768px'})

  return (
		<>
			<Modal {...{ isOpen, close }}>
				{profile?.access_level=== 'restricted' ? 
					<div className={s.alertCard}>
							<div className={s.title}>Проверьте почту</div>
							<div className={s.text}>Подтвердите регистрацию, чтобы начать заниматься</div>
					</div>
				: <div className={s.card}>
					{!isLoading ? (
						<>	
							<div className={s.row}>
								<Slider teacher={teacher}/>
								<div className={s.contentCol}>
									<div className={s.baseInfoContent}>
										<h5 className={s.name}>
										{getFullName(teacher)}
										</h5>
										<div className={s.infos}>
											<p><TextWithEmoji text={'🌟'}/> {teacher?.rating}</p>
											{/* <p><TextWithEmoji text={'📖'}/>  {getAppointmentCount(teacher)}{getNoun(getAppointmentCount(teacher), " занятие", " занятия", " занятий")}</p> */}
											<p>
												<TextWithEmoji text={'💬'}/>  {teacher?.reviews?.length}{" "}
												{getNoun(teacher?.reviews?.length, "отзыв", "отзыва", "отзывов")}
											</p>
										</div>
									</div>
									<div className={s.teacherInfo}>
										<div className={s.desc}>
											<span className={s.descLabel}>О себе</span>
											<TextCollapse maxHeight={91} className={s.descContent}>
												{teacher?.teacher_bio}
											</TextCollapse>
										</div>
										<div className={s.instruments}>
											{teacher?.instruments?.map((i) => (
												<div className={s.instrumentTag}><TextWithEmoji text={i.name}/></div>
											))}
										</div>
										{teacher?.education?.length > 0 ? <div className={s.education}>
											<span className={s.educationLabel}>Образование и опыт</span>
												{teacher?.education?.map((e) => (
													<span className={s.educationContent}>
														<IconCheck className={s.icon} />
														{e?.organization}
													</span>
												))}
										</div> : null}
									</div>
									<div className={s.btns}>
										<Button
											label="Записаться на занятие"
											className={s.btn}
											onClick={() => {
												close();
												navigate("/teacher/" + teacher?.teacher_slug);
												window.ym(96194074,'reachGoal','to-choose-date-from-modal')
											}}
										/>
										<CopyButton text={'https://sozvuchno.ru/teacher/' + teacher?.teacher_slug} label={<IconShare2 size={16}/>} icon={false} className={s.shareBtn} theme="secondary" size="small"/>
									</div>
									<Reviews reviews={teacher?.reviews} rating={teacher?.rating} />
								</div>
							</div>
						</>
					) : isMobile ? <Spinner/> : <Loader />}
				</div>}
			</Modal>
		</>
  );
};
